import React, { ChangeEvent, useEffect, useState } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { useEventContext } from '../../../context/EventProvider';
import { useRegistrationStore } from '../../../store/registrationStore';
import useSessionStore from '../../../store/useSessionsStore';
import Title from '../Title';
import { AttendeeDetailsStepData, StepDataMap } from './index';

const InterestStep = () => {
  const { sessions } = useEventContext();
  const { userData, updateUserData, markStepValidated, currentStep } = useRegistrationStore();
  const { selectedSessions, toggleSession } = useSessionStore();
  const [localSelectedSessions, setLocalSelectedSessions] =
    useState(selectedSessions);
  const {
    control,
    trigger
  } = useForm<AttendeeDetailsStepData>({
    defaultValues: userData.attendeeDetailsStep || {},
    mode: 'onChange'
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const value = e.target.value;
    const name = e.target.name;
    const targetSession = sessions.find(session => session.title === name);

    toggleSession(targetSession);

    const newData: StepDataMap['interestStep'] = {
      name: value
    };

    updateUserData('interestStep', newData);
    if (value !== '') {
      markStepValidated(currentStep);
    } else {
      markStepValidated(currentStep, false);
    }
  };

  const watchedFields = useWatch({ control });

  const validateFields = async () => {
    const isValid = await trigger();
    if (isValid) {
      const updatedFields = {
        ...userData.attendeeDetailsStep,
        ...watchedFields
      };

      updateUserData(
        'attendeeDetailsStep',
        updatedFields as AttendeeDetailsStepData
      );
      const { email, firstName, lastName, jobTitle, company, zipCode } =
        updatedFields;
      const allFieldsFilled = !!(
        email &&
        firstName &&
        lastName &&
        jobTitle &&
        company &&
        zipCode
      );
      markStepValidated(0, allFieldsFilled);
    } else {
      markStepValidated(0, false);
    }
  };

  useEffect(() => {
    validateFields();
  }, [watchedFields]);

  useEffect(() => {
    // Update local state when selectedSessions changes
    setLocalSelectedSessions(selectedSessions);
    // Perform validation check based on selected sessions
    if (selectedSessions.length > 0) {
      markStepValidated(currentStep, true);
    } else {
      markStepValidated(currentStep, false);
    }
  }, [selectedSessions, markStepValidated, currentStep]);

  return (
    <form className="space-y-6 my-5">
      <Title title="Register for Sessions Now!" />
      <div className="field-container checkbox overflow-y-scroll">
        {sessions
          .filter(session => session.slug)
          .map(session => {
            const { title, starts } = session;
            const isSelected = localSelectedSessions.some(
              s => s.title === session.title
            );
            const value = title
              .toLowerCase()
              .replace(',', '-')
              .replace(' ', '-');

            return (
              <div className="my-[0.75px]" key={title}>
                <input
                  className="translate-y-[2px] focus:ring-red-600 ring-offset-gray-800 focus:ring-2"
                  type="checkbox"
                  id={`startTime: ${starts}, and title: ${title}`.toLowerCase()}
                  name={title}
                  value={value}
                  checked={isSelected}
                  onChange={handleChange}
                />
                <label htmlFor={title} className="text-sm ml-2">
                  {title}
                </label>
              </div>
            );
          })}
      </div>
    </form>
  );
};

export default InterestStep;
